import extractDomain from "extract-domain";

/**
 * UserType is used by product for analytics purposes.
 * It does not determine any roles or permissions.
 */
export enum UserType {
  granular = "granular",
  internal = "internal",
  external = "external",
  unknown = "unknown",
}

enum DomainType {
  granular = "granular.ag",
  corteva = "corteva.com",
  pioneer = "pioneer.com",
  plantPioneer = "plantpioneer.com",
}

/**
 * Derives UserType from email address.
 * Used for analytics purposes only.
 * @returns UserType.unknown if email is undefined or empty.
 */
export const getUserType = (email: string | undefined): UserType => {
  if (!email) {
    return UserType.unknown;
  }

  try {
    const domain: string = extractDomain(email);

    // User Types as defined by Product
    switch (domain) {
      case DomainType.granular:
        return UserType.granular;
      case DomainType.corteva:
      case DomainType.pioneer:
      case DomainType.plantPioneer:
        return UserType.internal;
      default:
        return UserType.external;
    }
  } catch {
    return UserType.unknown;
  }
};
